// Tekster for pipeline pakke 3 (Tapt og gjenåpning). Egen fil så delene av
// pakken kan bygges hver for seg.
export const norwegianPipelineLostMessages = {
  crm: {
    deals: {
      lost: {
        title: "Marker som tapt",
        title_bulk: "Marker %{smart_count} muligheter som tapt",
        description:
          "Hvorfor ble det ikke noe av? Det hjelper oss å vinne neste gang.",
        description_bulk:
          "Årsaken og valgene under gjelder alle de valgte åpne mulighetene.",
        confirm: "Marker som tapt",
        reason: "Tapsårsak",
        reason_required: "Velg en tapsårsak.",
        competitor: "Hvem valgte de?",
        competitor_search: "Søk etter konkurrent",
        competitor_unknown: "Ukjent",
        competitor_add: "Legg til «%{name}»",
        competitor_added: "%{name} er lagt til i konkurrentregisteret",
        competitor_none: "Ingen treff",
        competitor_required: "Skriv hvem kunden valgte, eller velg «Ukjent».",
        comment: "Kommentar",
        comment_required: "Skriv en kommentar for denne årsaken.",
        learning: "Hva kunne vi gjort annerledes?",
        revisit: "Ta kontakt igjen om",
        revisit_none: "Ingen",
        revisit_months: "%{smart_count} mnd",
        revisit_date: "Dato …",
        revisit_date_label: "Dato for revisit",
        revisit_task: "→ Revisit-oppgave %{date}",
        nurture: "Legg i «Nurture – tidligere tapt» (samtykke: ja)",
        nurture_plain: "Legg i «Nurture – tidligere tapt»",
        nurture_no_contacts: "Muligheten har ingen kontakter.",
        nurture_no_consent: "Ingen kontakt har gitt samtykke.",
        nurture_opted_out: "Kontakten har meldt seg av.",
        draft: "Lag avslutningsutkast til %{name}",
        draft_plain: "Lag avslutningsutkast",
        draft_no_email: "Ingen kontakt har e-postadresse.",
        draft_subject: "Takk for dialogen",
        draft_body:
          "Hei %{name},\n\nTakk for at du tok deg tid til å snakke med oss. Vi forstår at det ikke ble noe denne gangen. Ta gjerne kontakt om noe endrer seg – vi hjelper gjerne.\n\nVennlig hilsen",
        lost_date: "Tapt dato",
        open_tasks: "Åpne oppgaver (%{smart_count})",
        open_tasks_complete: "Marker som fullført",
        open_tasks_delete: "Slett",
        open_tasks_keep: "Behold",
        postpone_hint: "Ikke tapt, bare senere? Utsett i stedet →",
        follow_up_hint:
          "Vi har fulgt opp %{smart_count} gang. Vil du sende én oppfølging til først? |||| Vi har fulgt opp %{smart_count} ganger. Vil du sende én oppfølging til først?",
        follow_up_action: "Planlegg oppfølging",
        done: "%{name} er markert som tapt.",
        done_bulk: "%{smart_count} muligheter er markert som tapt.",
        undo: "Angre",
        undone: "Angret. Muligheten er åpen igjen.",
        undo_too_late: "For sent å angre – åpne muligheten og gjenåpne den",
        competitor_label: "Konkurrent",
        comment_label: "Kommentar",
        learning_label: "Læring",
        revisit_label: "Revisit",
        automation_failed: "Noen automasjoner etter tapet feilet.",
        automation_retry: "Prøv igjen",
        automation_retried: "Automasjonene er kjørt på nytt",
      },
      postpone: {
        action: "Utsett",
        title: "Utsett",
        description:
          "Muligheten blir stående åpen. Når skal vi ta den opp igjen?",
        revisit: "Ta opp igjen",
        revisit_months: "%{smart_count} mnd",
        revisit_date: "Dato",
        expected_close: "Ny forventet avslutning",
        task_title: "Tittel på oppgaven",
        default_title: "Ta opp igjen",
        note: "Notat",
        confirm: "Utsett",
        revisit_required: "Velg når vi skal ta det opp igjen.",
        done: "%{name} er utsatt til %{date}",
      },
    },
  },
};

export const englishPipelineLostMessages = {
  crm: {
    deals: {
      lost: {
        title: "Mark as lost",
        title_bulk: "Mark %{smart_count} opportunities as lost",
        description: "Why didn't it work out? It helps us win next time.",
        description_bulk:
          "The reason and choices below apply to all selected open opportunities.",
        confirm: "Mark as lost",
        reason: "Loss reason",
        reason_required: "Choose a loss reason.",
        competitor: "Who did they choose?",
        competitor_search: "Search competitors",
        competitor_unknown: "Unknown",
        competitor_add: "Add “%{name}”",
        competitor_added: "%{name} was added to the competitor register",
        competitor_none: "No matches",
        competitor_required:
          "Enter who the customer chose, or choose “Unknown”.",
        comment: "Comment",
        comment_required: "Write a comment for this reason.",
        learning: "What could we have done differently?",
        revisit: "Get back in touch in",
        revisit_none: "None",
        revisit_months: "%{smart_count} mo",
        revisit_date: "Date …",
        revisit_date_label: "Revisit date",
        revisit_task: "→ Revisit task %{date}",
        nurture: "Add to “Nurture – previously lost” (consent: yes)",
        nurture_plain: "Add to “Nurture – previously lost”",
        nurture_no_contacts: "The opportunity has no contacts.",
        nurture_no_consent: "No contact has given consent.",
        nurture_opted_out: "The contact has unsubscribed.",
        draft: "Create closing draft to %{name}",
        draft_plain: "Create closing draft",
        draft_no_email: "No contact has an email address.",
        draft_subject: "Thank you for the conversation",
        draft_body:
          "Hi %{name},\n\nThank you for taking the time to talk with us. We understand it didn't work out this time. Feel free to get in touch if anything changes – we're happy to help.\n\nBest regards",
        lost_date: "Lost date",
        open_tasks: "Open tasks (%{smart_count})",
        open_tasks_complete: "Mark as completed",
        open_tasks_delete: "Delete",
        open_tasks_keep: "Keep",
        postpone_hint: "Not lost, just later? Postpone instead →",
        follow_up_hint:
          "We have followed up %{smart_count} time. Do you want to send one more follow-up first? |||| We have followed up %{smart_count} times. Do you want to send one more follow-up first?",
        follow_up_action: "Plan follow-up",
        done: "%{name} is marked as lost.",
        done_bulk: "%{smart_count} opportunities are marked as lost.",
        undo: "Undo",
        undone: "Undone. The opportunity is open again.",
        undo_too_late: "Too late to undo – open the opportunity and reopen it",
        competitor_label: "Competitor",
        comment_label: "Comment",
        learning_label: "Learning",
        revisit_label: "Revisit",
        automation_failed: "Some automations after the loss failed.",
        automation_retry: "Try again",
        automation_retried: "The automations have run again",
      },
      postpone: {
        action: "Postpone",
        title: "Postpone",
        description:
          "The opportunity stays open. When should we pick it up again?",
        revisit: "Pick up again",
        revisit_months: "%{smart_count} mo",
        revisit_date: "Date",
        expected_close: "New expected close",
        task_title: "Task title",
        default_title: "Pick up again",
        note: "Note",
        confirm: "Postpone",
        revisit_required: "Choose when to pick it up again.",
        done: "%{name} is postponed until %{date}",
      },
    },
  },
};
